import React, { useRef } from 'react';
import uniqid from '../../helpers/uniqid';

const SwitchButton = ({
                          variant = 'default',
                          className = '',
                          name = '',
                          value = '',
                          checked = false,
                          disabled = false,
                          changeFn = () => {}
                      }) => {
    const idAttr = useRef(uniqid());
    const switchIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <g filter="url(#filter0_dii_54_9713)">
                <rect className="rect1" x="8" y="8" width="10" height="10" rx="3" fill="currentColor"/>
            </g>
            <g filter="url(#filter1_d_54_9713)">
                <rect className="rect2" x="11" y="11" width="4" height="4" rx="1" fill="currentColor"/>
            </g>
            <defs>
                <filter id="filter0_dii_54_9713" x="4" y="4" width="18" height="18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.1564 0 0 0 0 0.190133 0 0 0 0 0.23 0 0 0 1 0"/>
                    <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_54_9713"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_9713" result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="-1"/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.278431 0 0 0 0 0.768627 0 0 0 0 0.980392 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_54_9713"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="1"/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.109804 0 0 0 0 0.129412 0 0 0 1 0"/>
                    <feBlend mode="normal" in2="effect2_innerShadow_54_9713" result="effect3_innerShadow_54_9713"/>
                </filter>
                <filter id="filter1_d_54_9713" x="0" y="0" width="26" height="26" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="5.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.301961 0 0 0 0 0.788235 0 0 0 0 0.988235 0 0 0 1 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_9713"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_9713" result="shape"/>
                </filter>
            </defs>
        </svg>
    );

    const combinedClassName = `fieldSwitchButton fieldSwitchButton--${variant} ${className}`;

    return (
        <label htmlFor={idAttr.current} className={combinedClassName}>
            <input id={idAttr.current}
                   type="checkbox"
                   checked={checked}
                   name={name}
                   value={value}
                   disabled={disabled}
                   onChange={(e) => changeFn(e.target.checked ? name : '', name)}/>
            <span className="fieldSwitchButton__inner">
                {switchIcon}
            </span>
        </label>
    );
};

export default SwitchButton;